import { createVuetify } from 'vuetify';
import vuetifyConfig from '@ui/configs/vuetify';

export const initVuetify = (app) => {
  const vuetify = createVuetify({
    ...vuetifyConfig,
  });

  app.use(vuetify);
};
